import { render } from "./Register.vue?vue&type=template&id=44569721&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=44569721&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44569721"]])

export default __exports__